import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useCallback,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import { showDialog } from "@widgets/CommonDialog";
import SnResizableUND from "@shared/components/SnResizableUND";
import SharedForm from "@widgets/SharedForm";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_EST_REG_001_POP_CARD03 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    const SharedFormref1 = useRef<any>();

    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [sharedForm, setSharedForm] = useState<any[]>([]);
    const [focusedRowData, setFocusedRowData] = useState<any>();

    //#endregion

    let height1 = "60.5%";
    let height2 = "1.5%";
    const menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const menu = JSON.parse(menuSize);
      if (menu.SN_SAL_EST_REG_001_POP_CARD03) {
        height1 = menu.SN_SAL_EST_REG_001_POP_CARD03.grid1Height
          ? menu.SN_SAL_EST_REG_001_POP_CARD03.grid1Height
          : height1;
        height2 = menu.SN_SAL_EST_REG_001_POP_CARD03.grid2Height
          ? menu.SN_SAL_EST_REG_001_POP_CARD03.grid2Height
          : height2;
      }
    }
    const [grid1Height, setGrid1Height] = useState<string | number>(height1);
    const [grid2Height, setGrid2Height] = useState<string | number>(height2);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const modifiedRows = gridApiRefH.current?.getChange();
        let lsChk: any = "2";
        if (modifiedRows.modifiedRowcount === 0) {
          lsChk = "1";
        } else {
          lsChk = "2";
        }

        if (lsChk === "1") {
          return { flag: false, message: "변경된 내용이 없습니다." };
        }
        return { flag: true };
      },
      getSelectedValue: async () => {
        await onSave(); // assumes it only saves modified rows
        return "success";
      },
      getSelectedRow: () => [gridApiRefH.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp(
            "SN_SAL_EST_REG_001_POP_CARD03",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setSharedForm(rtn.form.freeform1);
          setTimeout(() => {
            onSearch();
          }, 50);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo, selectedData]);

    //#region onSearch
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_sal_est_reg_001_POP_CARD03_01",
            params: searchRef.current.getFormdata(),
          };

          setDataSource1([]);
          const data: any = await fnGetDataSet(params);

          let rows = data[0] || [];

          rows = rows.map((row: any) => ({
            ...row,
            cd_source: selectedData?.cd_source ?? row.cd_source,
            nm_source: selectedData?.nm_cust ?? row.nm_source,
          }));

          setDataSource1(rows);

          if (rows.length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));
            gridApiRefH.current.selectAndFocusRow(0);
          }

          gridApiRefH.current.resetUpdate();
        } catch (error) {}
      };
      await fetchdatasource();
    };
    //#region onSave
    const onSave = async () => {
      try {
        gridApiRefH.current.api.stopEditing();
        const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();
        if (!requiredValuesCheckH) {
          return;
        }
        const changesRow = gridApiRefH.current.getChange();
        if (changesRow.update) {
          changesRow.update = changesRow.update.map((row: any) => ({
            ...row,
            cd_user_amd: userInfo.cd_user,
            nm_user_amd: userInfo.nm_user,
          }));
        }
        const SaveData = {
          sfa_namecard: changesRow,
        };
        if (changesRow.modifiedRowcount === 0) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return;
        }
        // 저장 API 호출
        await fnSave("SN_SAL_EST_REG_001_SAVE_01", SaveData);

        gridApiRefH.current.resetUpdate();
      } catch (error: any) {}
    };

    const onResizeStopH = (height: number) => {
      setGrid1Height(height);
    };

    // grid2의 width resize
    const onResizeStopL = (height: number) => {
      setGrid2Height(height);
    };
    //#region onFocusedRowChanged
    const onFocusedRowChanged = useCallback((focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    }, []);
    //#region onValueChanged
    const onValueChanged = async (data: any, param: string, formData: any) => {
      const norm = (v: any) => (v == null ? "" : String(v).trim());

      switch (param) {
        case "no_tel1":
        case "no_tel2":
        case "no_tel3": {
          const tel1 = norm(param === "no_tel1" ? data : formData?.no_tel1);
          const tel2 = norm(param === "no_tel2" ? data : formData?.no_tel2);
          const tel3 = norm(param === "no_tel3" ? data : formData?.no_tel3);
          return { no_tel: [tel1, tel2, tel3].filter(Boolean).join("-") };
        }

        case "no_hp1":
        case "no_hp2":
        case "no_hp3": {
          const hp1 = norm(param === "no_hp1" ? data : formData?.no_hp1);
          const hp2 = norm(param === "no_hp2" ? data : formData?.no_hp2);
          const hp3 = norm(param === "no_hp3" ? data : formData?.no_hp3);
          return { no_hp: [hp1, hp2, hp3].filter(Boolean).join("-") };
        }

        default:
          return {};
      }
    };

    //#endregion
    //#region UI
    return (
      <div className="h-full flex flex-col">
        <div className="flex-1 h-full min-h-0">
          <SnResizableUND
            height={grid1Height}
            minHeight={350}
            onResizeStop={onResizeStopH}
            enable={{ bottom: true }}
            menuName={modalRef.cd_menu || "SN_SAL_EST_REG_001_POP_CARD03"}
            defaultSize={{ grid1Height: grid1Height }}
          >
            <SharedForm
              ref={SharedFormref1}
              data={focusedRowData}
              controls={sharedForm}
              gridref={gridApiRefH}
              menuInfo={modalRef}
              onValueChaged={onValueChanged}
            />
          </SnResizableUND>

          <div style={{ opacity: 0 }}>
            <SnResizableUND
              height={grid2Height}
              minHeight={130}
              onResizeStop={onResizeStopL}
              enable={{ bottom: true }}
              menuName={modalRef.cd_menu || "SN_SAL_EST_REG_001_POP_CARD03"}
              defaultSize={{ grid2Height: grid2Height }}
            >
              <SnGrid
                ref={gridApiRefH}
                menuInfo={modalRef}
                enableAddRow={true}
                columnConfig={columns1} // 컬럼 설정 전달
                rowData={dataSource1}
                onFocusedRowChanged={onFocusedRowChanged}
                isEditable={false}
              />
            </SnResizableUND>
          </div>
        </div>
        <div style={{ opacity: 0 }}>
          <div className="mb-1">
            <SearchPanel
              ref={searchRef}
              data={formData}
              controls={formControlData}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_SAL_EST_REG_001_POP_CARD03; // 20250816
